"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const theme_1 = require("@zapier/theme");
const design_system_1 = require("@zapier/design-system");
const Styles = common_utils_1.labelStyles(__filename, {
    root: {
        padding: `${theme_1.Spacing.medium}px ${theme_1.Spacing.small}px`,
    },
});
function EmptyCustomMapper() {
    return (common_utils_1.isolateComponent("div", { css: Styles.root },
        common_utils_1.isolateComponent(design_system_1.Text, { color: "grey500", type: "altText900" }, "There are no custom choices available. You can type a value.")));
}
exports.default = EmptyCustomMapper;
